import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SummaryStatProps {
  label: string;
  value: number;
  // Отсутствует, когда числу не назначен смысловой окрас: тогда действует
  // нейтральный "default" и значение не выделяется.
  color?: "default" | "warning" | "info" | "error";
}

export function SummaryStat(props: SummaryStatProps) {
  const { label, value, color = "default" } = props;
  const isHighlighted = value > 0 && color !== "default";
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          color: isHighlighted ? `${color}.main` : "text.primary",
          fontWeight: 600,
          lineHeight: 1.2,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
